var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-side-panel-state"},[_c('i',{staticClass:"iconoir-pc-mouse empty-side-panel-state__icon"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('emptySidePanelState.message')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }